import React, { Component } from "react";
import { connect } from "react-redux";

import { buildParamsFromState, buildUrlFromParams } from "../utils/url.write";

import { hideEditingModals, saveEditedStateToServer, showCancelModal, showSaveModal } from "../core/actions/editing";
import { setAppLoading, setAppLoadingPromise } from "../core/actions/loading";


const _SaveButtons = ({ dispatch }) => (
    <div className="u-hidden-small">
        <button onClick={ () => dispatch( showSaveModal() ) } className="btn is-blue flex-item--center xmd-ml--small cursor-pointer">
            Save changes
        </button>
        <button onClick={ () => dispatch( showCancelModal() ) } className="flex-item--center u-m-reset u-p--reset button-reset u-ml--xsmall cursor-pointer">
            Cancel
        </button>
    </div>
);

const SaveButtons = connect()(_SaveButtons);


class _SaveChangesModal extends Component {

    getModalClassName() {
        if ( this.props.saveModalVisible ) {
            return 'modal';
        } else {
            return 'u-hidden modal--hidden';
        }
    }

    closeAndResume() {
        this.props.dispatch( hideEditingModals() );
    }

    closeAndSave() {
        this.props.dispatch( hideEditingModals() );
        this.props.dispatch( setAppLoading() );
        // data should be saved to the data endpoint for the current register
        this.props.dispatch( saveEditedStateToServer(`${location.pathname}data/`) );
    }

    render() {

        return (
            <div className={ this.getModalClassName() }>
                <div className="small-modal u-flex flex--column">
                    <h2>Save changes?</h2>
                    <p className="wrapper--xxsmall u-m-reset u-mt--xsmall">
                        This save the changes you have made.
                    </p>
                    <div className="u-mt--xsmall">
                        <button onClick={ () => this.closeAndSave() } className="btn btn--blue u-mr--xsmall u-mb--xsmall button-reset">
                            Save changes
                        </button>
                        <button onClick={ () => this.closeAndResume() } className="btn btn--secondary--white u-mb--xsmall button-reset">
                            Continue editing
                        </button>
                    </div>
                    <button onClick={ () => this.closeAndResume() } className="register-modal__close button-reset">
                        <svg className="icon-close-small" style={{width: '16px', height: '16px'}}>
                            <use xlinkHref="#icon-close-small"></use>
                        </svg>
                    </button>
                </div>
            </div>
        );
    }
}

const SaveChangesModal = connect((state) => ({
    saveModalVisible: state.mutableEditing.showSaveModal,
}))(_SaveChangesModal);


class _CancelChangesModal extends Component {

    getModalClassName() {
        if ( this.props.cancelModalVisible ) {
            return 'modal';
        } else {
            return 'u-hidden modal--hidden';
        }
    }

    closeAndAbort(e) {
        e.preventDefault();
        this.props.dispatch( hideEditingModals() );
        this.props.dispatch( setAppLoadingPromise() )
            .then(() => {
                const newUrl = this.buildNonEditUrl();
                location.assign(newUrl)
            })
    }

    closeAndResume() {
        this.props.dispatch( hideEditingModals() )
    }

    buildNonEditUrl() {
        const { immutableBaseData, mutableFiltering, mutableSearching, mutableSorting } = this.props;
        const stateItems = { immutableBaseData, mutableFiltering, mutableSearching, mutableSorting };

        const params = buildParamsFromState(stateItems);

        return buildUrlFromParams(location.pathname, params);
    }

    render() {

        return (
            <div className={ this.getModalClassName() }>
                <div className="small-modal u-flex flex--column">
                    <h2>Undo changes?</h2>
                    <p className="wrapper--xxsmall u-m-reset u-mt--xsmall">
                        This will cancel the changes you have made to this register and delete them permanently.
                    </p>
                    <div className="u-mt--xsmall">
                        <button onClick={ () => this.closeAndResume() } className="btn btn--secondary--white u-mr--xsmall u-mb--xsmall button-reset">
                            Continue editing
                        </button>
                        <button onClick={ (e) => this.closeAndAbort(e) } className="btn btn--blue u-mb--xsmall">
                            Delete changes
                        </button>
                    </div>
                    <button onClick={ () => this.closeAndResume() } className="register-modal__close button-reset">
                        <svg className="icon-close-small" style={{width: '16px', height: '16px'}}>
                            <use xlinkHref="#icon-close-small"></use>
                        </svg>
                    </button>
                </div>
            </div>
        );
    }
}


const CancelChangesModal = connect((state) => ({
    cancelModalVisible: state.mutableEditing.showCancelModal,
    // we need the rest of this state in order to generate correct urls... we could probably do this better.
    immutableBaseData: state.immutableBaseData,
    mutableFiltering: state.mutableFiltering,
    mutableSearching: state.mutableSearching,
    mutableSorting: state.mutableSorting,
}))(_CancelChangesModal);


class _EditButtons extends Component {

    buildEditUrl() {
        const { immutableBaseData, mutableFiltering, mutableSearching, mutableSorting } = this.props;
        const stateItems = { immutableBaseData, mutableFiltering, mutableSearching, mutableSorting };

        const params = buildParamsFromState(stateItems);
        params['edit'] = [true];  // expects arrays of values

        return buildUrlFromParams(location.pathname, params);
    }

    handleClick(e) {
        e.preventDefault();
        const newUrl = this.buildEditUrl();
        this.props.dispatch( setAppLoadingPromise() )
            .then(() => location.assign(newUrl))
    }

    render() {
        return (
            <div className="u-hidden-small">
                <button onClick={(e) => this.handleClick(e)} className="btn is-blue flex-item--center xmd-ml--small cursor-pointer">
                    Edit
                </button>
            </div>
        );
    }
};



const EditButtons = connect((state) => ({
    // we need this state in order to generate correct urls... we could probably do this better.
    immutableBaseData: state.immutableBaseData,
    mutableFiltering: state.mutableFiltering,
    mutableSearching: state.mutableSearching,
    mutableSorting: state.mutableSorting,
}))(_EditButtons);


const EditControls = ({ editingEnabled }) => (
    <div className="u-flex flex--center">
        <div className="xmd-flex u-bl-thin">
            { editingEnabled ? <SaveButtons /> : <EditButtons /> }
        </div>
        <SaveChangesModal />
        <CancelChangesModal />
    </div>
);

export default connect((state) => ({ editingEnabled: state.immutableEditing.editingEnabled }))(EditControls);
